import { apiSlice } from './apiSlice';

export const authApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    sendOtp: builder.mutation<
      { message: string },
      { mobile: string; type: string; country: string | undefined }
    >({
      query: (body) => ({
        url: '/auth/mobile/send-code',
        method: 'POST',
        body,
      }),
    }),
    verifyMobile: builder.mutation<{ message: string }, { mobile: string; code: string }>({
      query: (body) => ({
        url: '/auth/mobile/verify',
        method: 'POST',
        body,
      }),
    }),
    // Login
    login: builder.mutation<
      { accessToken: string; user: any; passwordChanged: Boolean },
      {
        identifier: string;
        password: string;
      }
    >({
      query: (body) => ({
        url: '/auth/login',
        method: 'POST',
        body,
      }),
    }),
    registerUser: builder.mutation<
      { success: boolean; data: any; message?: string },
      {
        username: string;
        password: string;
        dialCode: string;
        mobile: string;
        country: string | undefined;
        referralCode?: string;
      }
    >({
      query: (body) => ({
        url: '/auth/register',
        method: 'POST',
        body,
      }),
    }),
    //logout
    logout: builder.mutation<any, void>({
      query: () => ({
        url: '/auth/logout',
        method: 'POST',
      }),
    }),
    // forgot password
    forgotPassword: builder.mutation<{ success: boolean; message: string }, { mobile: string }>({
      query: (body) => ({
        url: '/auth/forgot-password',
        method: 'POST',
        body,
      }),
    }),
    // reset password
    resetPassword: builder.mutation<
      { success: boolean; message: string },
      { code: string; newPassword: string; mobile: string }
    >({
      query: (body) => ({
        url: '/auth/reset-password',
        method: 'POST',
        body,
      }),
    }),
    // new captcha endpoint
    getCaptcha: builder.query<any, void>({
      query: () => ({
        url: '/captcha',
        method: 'POST',
      }),
    }),
    // change password
    changePassword: builder.mutation({
      query: (body: { oldPassword: string; newPassword: string }) => ({
        url: '/users/me/change-password',
        method: 'POST',
        body,
      }),
    }),
    getUser: builder.query<any, void>({
      query: () => ({ url: '/users/me', method: 'GET', params: { ts: Date.now() } }),
      providesTags: ['Auth'],
    }),
    // verify phone number with OTP
    verifyPhoneNumber: builder.mutation<
      { success: boolean; message: string },
      { code: string; mobile: string }
    >({
      query: (body) => ({
        url: '/auth/mobile/verify',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useGetCaptchaQuery,
  useLazyGetCaptchaQuery,
  useRegisterUserMutation,
  useLoginMutation,
  useLogoutMutation,
  useGetUserQuery,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useChangePasswordMutation,
  useSendOtpMutation,
  useVerifyPhoneNumberMutation,
  useVerifyMobileMutation,
} = authApi;
// {
//     "username": "testuser",
//     "password": "Test@123",
//     "dialCode": "+91",
//     "mobile": "+919874656856",
//     "country": "IN"
// }
